<template>
  <main class="main page-inside payment-result-page">
    <div class="section payment-section">
      <div class="page-inside-top">
        <div class="wrapper">
          <div class="title big">
            {{ $t("Your payment is still being processed. Please wait.") }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "PaymentProcessingPage",
  data() {
    return {
      pollTimer: null,
      attempts: 0,
      maxAttempts: 150,
    };
  },
  mounted() {
    this.checkStatus();
    this.pollTimer = window.setInterval(this.checkStatus, 4000);
  },
  beforeUnmount() {
    this.clearPolling();
  },
  methods: {
    clearPolling() {
      if (this.pollTimer) {
        window.clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async checkStatus() {
      const orderId = this.$route.query.order_id;

      if (!orderId) {
        this.clearPolling();
        this.$router.replace("/fail-payment");
        return;
      }

      if (this.attempts >= this.maxAttempts) {
        this.clearPolling();
        this.$router.replace(`/fail-payment?order_id=${orderId}`);
        return;
      }

      this.attempts += 1;

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API}purchase/payment-status/${orderId}`,
        );
        const status = response.data?.payload;

        if (status?.success) {
          this.clearPolling();
          this.$router.replace(`/success-payment?order_id=${orderId}`);
        } else if (status?.failed) {
          this.clearPolling();
          this.$router.replace(`/fail-payment?order_id=${orderId}`);
        }
      } catch (error) {
        if (this.attempts >= this.maxAttempts) {
          this.clearPolling();
          this.$router.replace(`/fail-payment?order_id=${orderId}`);
        }
      }
    },
  },
};
</script>
